import type { AdditionalItem } from '@/hooks';
import { useInputAndInputBase } from './useInputAndInputBase';

interface UseInputAndInputProps {
	additionalItem: AdditionalItem;
}

interface UseInputAndInputReturn {
	formFieldName: string[];
	localAdditionalItem: AdditionalItem;
	worstRisk: number;
	isAddDisabled: boolean;
	isCalculatingScore: boolean;
	handleAddAdditionalItemValueClick: () => Promise<void>;
	handleRemoveAdditionalItemClick: (removedId: string) => void;
}

export function useInputAndInput({ additionalItem }: Readonly<UseInputAndInputProps>): UseInputAndInputReturn {
	const {
		id,
		formFieldName,
		formValueOne,
		formValueTwo,
		localAdditionalItem,
		worstRisk,
		isCalculatingScore,
		persistResultEntry,
		handleRemoveAdditionalItemClick
	} = useInputAndInputBase({ additionalItem });

	async function handleAddAdditionalItemValueClick(): Promise<void> {
		const clearFieldName = [...formFieldName, 'additional_items', id];

		await persistResultEntry({ value_1: formValueOne, value_2: formValueTwo, clearFieldName });
	}

	const isAddDisabled = isCalculatingScore || !formValueOne || !formValueTwo;

	return {
		formFieldName,
		localAdditionalItem,
		worstRisk,
		isAddDisabled,
		isCalculatingScore,
		handleAddAdditionalItemValueClick,
		handleRemoveAdditionalItemClick
	};
}
